import type { persons as kycAcceptance } from '@repo/api-kit/kyc-acceptance';
import type { KycResponse } from '@repo/api-kit/queries/due-diligence/kyc';

export function getIdnowProviderDetails(
  kycInfo?: KycResponse
): kycAcceptance.firstparty.v1.ApiIdnowProviderDetails | null {
  return kycInfo?.activeProcess?.providerDetails?.$case === 'idnowProviderDetails'
    ? kycInfo.activeProcess.providerDetails.value
    : null;
}
